import { backgroundTransitionOnClick, IconFont, pointer, Text } from '@byecode/ui'
import { type ActorEvent, type ButtonConfigure, EVENT_TYPE, type EventsProtocol } from '@lighthouse/core'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { useApplicationContext } from '../../../../contexts'
import { useActionRunningLoadings } from '../../../../hooks'
import { getBackgroundStyle } from '../../../../utils'
import { useFillPickerContext } from '../../../FillPicker'

interface AddButtonProps {
    id: string
    isHover?: boolean
    config: Pick<ButtonConfigure, 'iconColor' | 'color' | 'iconPosition' | 'icon' | 'showType'> & { name: string } & EventsProtocol
    style?: React.CSSProperties
    onClickEvent?: (id: string, actorEvent: ActorEvent) => Promise<void>
    onClose: () => void
}

const SCxAdd = styled.div<{ isHover?: boolean }>`
    width: 100%;
    height: 40px;
    padding: 0 16px;
    gap: 8px;
    margin: 8px 0;
    display: flex;
    align-items: center;
    background-color: var(--color-white);
    ${({ isHover }) => isHover && backgroundTransitionOnClick}

    ${pointer}
`

export const AddButton: React.FunctionComponent<AddButtonProps> = ({ id, config, isHover, style, onClickEvent, onClose }) => {
    const { loadings, handleActionTriggerWithLoading } = useActionRunningLoadings()
    const { iconPosition, iconColor, color, name, icon, eventList, showType } = config
    const { palettes } = useFillPickerContext()
    const clickEvent = useMemo(() => eventList?.find(ev => ev.type === EVENT_TYPE.CLICK), [eventList])
    const { appId } = useApplicationContext()
    const showName = showType !== 'icon'
    const showIcon = showType !== 'name'
    const uniqueId = useMemo(() => `${id}-add`, [id])
    return (
        <SCxAdd
            style={style}
            isHover={isHover}
            onClick={() => {
                onClose()
                if (clickEvent && onClickEvent) {
                    handleActionTriggerWithLoading({
                        id: uniqueId,
                        actorEvent: clickEvent,
                        trigger: (id, actorEvent) => onClickEvent(id, actorEvent)
                    })
                }
            }}
        >
            {showIcon && icon && (
                <IconFont
                    type={icon}
                    size={16}
                    color={getBackgroundStyle({ appId, value: iconColor, palettes })?.backgroundColor}
                    style={{ order: iconPosition === 'left' ? 1 : 3 }}
                />
            )}
            {showName && (
                <Text color={getBackgroundStyle({ appId, value: color, palettes })?.backgroundColor} size={14} style={{ order: 2 }}>
                    {name}
                </Text>
            )}
        </SCxAdd>
    )
}
